export default __webpack_public_path__ + "locales/sq-AL/DeleteSelfProfileDialog.json?hash=423838a4877076c85df9c4c963318d5c";